if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.all_swatch_images = this.querySelectorAll('[data-alt-value]');
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }

        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        const hasValidDeepLink =
          urlVariantId &&
          this.currentVariant &&
          String(this.currentVariant.id) === String(urlVariantId);

        const color_field = this.querySelector('[data-field-option="color"]');
        const size_field = this.querySelector('[data-field-option="size"]');

        if (!hasValidDeepLink) {
          var checked_input = this.querySelectorAll('[data-fieldset] [data-option-value-id]:checked');
          if (color_field) {
            checked_input.forEach((input) => {
              input.removeAttribute('checked');
            });
          }

          if (checked_input.length> 0 && color_field) {
            const product_badges = this.querySelectorAll('[data-product-badge]');
            if (product_badges.length > 0) {
              product_badges.forEach(badge => {
                badge.style.display = 'none';
              });
            }

            if (size_field) {
              size_field.classList.add('is-locked');
              size_field.setAttribute('aria-disabled', 'true');
            }

            let swatch_selected_value = this.querySelectorAll('[data-selected-swatch-value]');
            if(swatch_selected_value.length > 0) {
              swatch_selected_value.forEach((item) => {
                item.textContent = "";
              });
            }
            const submitButton = this.querySelector('[name="add"]');
            if (submitButton) {
              submitButton.setAttribute('disabled', 'disabled');
              const submitSpan = submitButton.querySelector('span');
              if (submitSpan) submitSpan.textContent = FoxTheme.variantStrings.selectColor;
            }
          }
        }
      }

      disconnectedCallback() {
        if (typeof this.onVariantChangeUnsubscriber === 'function') {
          this.onVariantChangeUnsubscriber();
          this.onVariantChangeUnsubscriber = undefined;
        }
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.abortController?.abort();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        const allVariantsRaw = this.querySelector('variant-selects [data-all-variant]')?.innerHTML;
        let allVariants;
        try {
          allVariants = allVariantsRaw ? JSON.parse(allVariantsRaw) : null;
        } catch (e) {
          console.warn('product-info: failed to parse [data-all-variant]', e);
          return;
        }
        if (!Array.isArray(allVariants)) return;
        const submitButton = this.querySelector('[type="submit"]');
        const paymentButton = this.querySelector('.shopify-payment-button__button');
        if (event.target.closest('[data-fieldset]')?.classList.contains('color')) {
          let size_radio = this.querySelector('[data-field-option="size"] [data-option-value-id]:checked');
          if(size_radio) {
            size_radio.checked = false;
          }
          var color_input_value = event.target?.value;
          this.querySelector('[data-selected-swatch-value="Color"]').textContent = color_input_value;
          this.querySelector('[data-selected-swatch-value="Size"]').textContent = "";
          const selectedOptions = allVariants.filter((item) => {
            if (item.option1 == color_input_value) {
              return item;
            }
          });
          this.updateMedia(selectedOptions[0]);
          let all_size_inputs = this.querySelectorAll('[data-field-option="size"] [data-option-value-id]');
          all_size_inputs.forEach((input) => {
            let conditionMatch = false;
            selectedOptions.forEach((size_variant) => {
              if (size_variant.option2 && input.value == size_variant.option2) {
                if (size_variant.available == true) {
                  input.classList.remove('disabled');
                  input.classList.remove('non-existent');
                  input.classList.add('existent');
                  conditionMatch = true;
                } else if (size_variant.available == false) {
                  input.classList.add('disabled');
                  input.classList.add('non-existent');
                  input.classList.add('existent');
                  conditionMatch = true;
                }
              }
            });
            if(!conditionMatch) {
              input.classList.add('disabled');
              input.classList.add('non-existent');
              input.classList.remove('existent');
            }
          });
          const size_field = this.querySelector('[data-field-option="size"]');
          if (size_field) {
            size_field.classList.remove('is-locked');
            size_field.removeAttribute('aria-disabled');
          }
          if (submitButton && size_field) {
            submitButton.setAttribute('disabled', 'disabled');
            const submitSpan = submitButton.querySelector('span');
            if (submitSpan) submitSpan.textContent = FoxTheme.variantStrings.selectSize;
          }
          if (paymentButton && size_field) {
            paymentButton.setAttribute('disabled', 'disabled');
          }
          return;
        }
      
        var selectedOptionsList;
        if (event.target.closest('[data-fieldset]')?.classList.contains('size')) {
          let color_radio = this.querySelector('[data-field-option="color"] [data-option-value-id]:checked');
          const color_field = this.querySelector('[data-field-option="color"]');
          
          if (!color_field) {
            selectedOptionsList = null;
          } else {
            if (!color_radio) {
              if (submitButton) {
                submitButton.setAttribute('disabled', 'disabled');
                const submitSpan = submitButton.querySelector('span');
                if (submitSpan) submitSpan.textContent = FoxTheme.variantStrings.selectColor;
              }
              if (paymentButton) {
                paymentButton.setAttribute('disabled', 'disabled');
              }
              return;
            }
            var color_input_value = color_radio.value;
            const selectedOptions = allVariants.filter((item) => {
              if (item.option1 == color_input_value) {
                return item;
              }
            });
            selectedOptionsList = selectedOptions;
          }
        }
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode), 
            selectedOptions: selectedOptionsList,
        });
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      renderProductInfo({ requestUrl, targetId, callback, selectedOptions }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
            if (selectedOptions) {
              var all_size_inputs = this.querySelectorAll('[data-field-option="size"] [data-option-value-id]');
              all_size_inputs.forEach((input) => {
                let conditionMatch = false;
                selectedOptions.forEach((size_variant) => {
                  if (size_variant.option2 && input.value == size_variant.option2) {
                    if (size_variant.available == true) {
                      input.classList.remove('disabled');
                      input.classList.remove('non-existent');
                      input.classList.add('existent');
                      conditionMatch = true;
                    } else if (size_variant.available == false) {
                      input.classList.add('disabled');
                      input.classList.add('non-existent');
                      input.classList.add('existent');
                      conditionMatch = true;
                    }
                  }
                });
                if(!conditionMatch) {
                  input.classList.add('disabled');
                  input.classList.add('non-existent');
                  input.classList.remove('existent');
                }
              });
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        let swatch_value = this.querySelector("[data-swatch-input]:checked");
        if (swatch_value) {
          let swatch_title = swatch_value.value.replace(/\s+/g, '-').toLowerCase();
          swatch_title = `color_${swatch_title}`;
          let all_swatch_images = Array.from(this.all_swatch_images);
          let product_media = this.querySelector('[product-media-list]');
          const swatch_images = all_swatch_images.filter(
            (item) => item.getAttribute('data-alt-value') == swatch_title
          );
          const imagesToInsert = swatch_images.length > 0 ? swatch_images : all_swatch_images;
          const fragment = document.createDocumentFragment();
          imagesToInsert.forEach((image) => {
            fragment.appendChild(image.cloneNode(true));
          });
          product_media.replaceChildren(fragment);
          function reinitializeMediaGallery() {
            const event = new Event('reinitializeMediaGallery');
            document.dispatchEvent(event);
          }
          reinitializeMediaGallery();
          var product_media_images = product_media.querySelectorAll('.product__media.loading');
          if (product_media_images.length > 0) {
            product_media_images.forEach((item) => {
              item.classList.remove('loading');
            });
          }
          if (swatch_images.length == 0) {
            const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
            if (!productMedia) return;
            const setActiveMedia = () => {
              if (typeof productMedia.setActiveMedia === 'function') {
                productMedia.init();
                productMedia.setActiveMedia(variant);
                return true;
              }
              return false;
            };

            if (!setActiveMedia()) {
              if (this.timer) clearInterval(this.timer);
              let attempts = 0;
              this.timer = setInterval(() => {
                attempts += 1;
                if (setActiveMedia() || attempts >= 50) {
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 100);
            }
          }
        } else {
          const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
          if (!productMedia) return;
          const setActiveMedia = () => {
            if (typeof productMedia.setActiveMedia === 'function') {
              productMedia.init();
              productMedia.setActiveMedia(variant);
              return true;
            }
            return false;
          };

          if (!setActiveMedia()) {
            if (this.timer) clearInterval(this.timer);
            let attempts = 0;
            this.timer = setInterval(() => {
              attempts += 1;
              if (setActiveMedia() || attempts >= 50) {
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 100);
          }
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = FoxTheme.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }
    }
  );
}